import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminKYC from "./pages/admin/AdminKYC";
import DesktopOnly from "./components/DesktopOnly";

import CustomerHome from "./pages/customer/CustomerHome";
import CustomerServices from "./pages/customer/CustomerServices";
import CustomerServiceDetail from "./pages/customer/CustomerServiceDetail";
import CustomerWorkerProfile from "./pages/customer/CustomerWorkerProfile";
import CustomerBookings from "./pages/customer/CustomerBookings";
import CustomerBookingDetail from "./pages/customer/CustomerBookingDetail";
import CustomerBookingCreate from "./pages/customer/CustomerBookingCreate";
import CustomerProfile from "./pages/customer/CustomerProfile";

import WorkerHome from "./pages/worker/WorkerHome";
import WorkerKycTerms from "./pages/worker/WorkerKycTerms";
import WorkerBookings from "./pages/worker/WorkerBookings";
import WorkerBookingDetail from "./pages/worker/WorkerBookingDetail";
import WorkerServices from "./pages/worker/WorkerServices";
import WorkerProfile from "./pages/worker/WorkerProfile";
import WorkerFinance from "./pages/worker/WorkerFinance";
import NotificationsPage from "./pages/NotificationsPage";

export default function App() {
  const { user } = useAuth();

  const roleHome = user?.role === "ADMIN" ? "/admin" : user?.role === "WORKER" ? "/worker" : "/customer";

  return (
    <Routes>
      {/* Public */}
      <Route path="/" element={user ? <Navigate to={roleHome} replace /> : <Landing />} />
      <Route path="/login" element={user ? <Navigate to={roleHome} replace /> : <Login />} />
      <Route path="/register" element={user ? <Navigate to={roleHome} replace /> : <Register />} />

      {/* Admin (khusus desktop — diblokir di HP) */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute roles={["ADMIN"]}>
            <DesktopOnly>
              <AdminDashboard />
            </DesktopOnly>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/kyc"
        element={
          <ProtectedRoute roles={["ADMIN"]}>
            <DesktopOnly>
              <AdminKYC />
            </DesktopOnly>
          </ProtectedRoute>
        }
      />

      {/* Customer */}
      <Route
        path="/customer"
        element={
          <ProtectedRoute roles={["CUSTOMER"]}>
            <CustomerHome />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customer/services"
        element={
          <ProtectedRoute roles={["CUSTOMER"]}>
            <CustomerServices />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customer/services/:slug"
        element={
          <ProtectedRoute roles={["CUSTOMER"]}>
            <CustomerServiceDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customer/workers/:id"
        element={
          <ProtectedRoute roles={["CUSTOMER"]}>
            <CustomerWorkerProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customer/bookings"
        element={
          <ProtectedRoute roles={["CUSTOMER"]}>
            <CustomerBookings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customer/bookings/create/:workerId"
        element={
          <ProtectedRoute roles={["CUSTOMER"]}>
            <CustomerBookingCreate />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customer/bookings/:id"
        element={
          <ProtectedRoute roles={["CUSTOMER"]}>
            <CustomerBookingDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customer/profile"
        element={
          <ProtectedRoute roles={["CUSTOMER"]}>
            <CustomerProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/customer/notifications"
        element={
          <ProtectedRoute roles={["CUSTOMER"]}>
            <NotificationsPage />
          </ProtectedRoute>
        }
      />

      {/* Worker */}
      <Route
        path="/worker"
        element={
          <ProtectedRoute roles={["WORKER"]}>
            <WorkerHome />
          </ProtectedRoute>
        }
      />
      <Route
        path="/worker/kyc-terms"
        element={
          <ProtectedRoute roles={["WORKER"]}>
            <WorkerKycTerms />
          </ProtectedRoute>
        }
      />
      <Route
        path="/worker/bookings"
        element={
          <ProtectedRoute roles={["WORKER"]}>
            <WorkerBookings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/worker/bookings/:id"
        element={
          <ProtectedRoute roles={["WORKER"]}>
            <WorkerBookingDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/worker/services"
        element={
          <ProtectedRoute roles={["WORKER"]}>
            <WorkerServices />
          </ProtectedRoute>
        }
      />
      <Route
        path="/worker/finance"
        element={
          <ProtectedRoute roles={["WORKER"]}>
            <WorkerFinance />
          </ProtectedRoute>
        }
      />
      <Route
        path="/worker/profile"
        element={
          <ProtectedRoute roles={["WORKER"]}>
            <WorkerProfile />
          </ProtectedRoute>
        }
      />
      <Route
        path="/worker/notifications"
        element={
          <ProtectedRoute roles={["WORKER"]}>
            <NotificationsPage />
          </ProtectedRoute>
        }
      />

      {/* Legacy redirect */}
      <Route path="/dashboard" element={<Navigate to={roleHome} replace />} />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
